import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/vercel/path0/app/_graphql/ApolloWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_lib/monitoring/clarityProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_lib/monitoring/openReplyProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShadCnToaster"] */ "/vercel/path0/components/Toast/ToastNotification.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/tailwind.css");
